import {
    LocalShippingOutlined,
    EventNoteOutlined,
    MapRounded,
    Assessment,
    Settings,
    Person,
    Warehouse,
    FilterList,
    LinkOutlined,
    FiberManualRecord,
    Remove,
    Task,
    Group,
    Tune,
    AccountCircle,
    Paid,
    Wallet,
    ContactPage,
    ManageAccounts,
    Category,
    CreditCard,
    Gavel,
    WhatsApp,
    LocationOn
} from "@mui/icons-material";


export const LAST_MILE_TABS = [
    {
        href: "/merchant",
        icon: Assessment,
        title: "Statistics",
        listItemIconStyle: { minWidth: 35 },
    },
    {
        href: `/merchant/orders/zone_orders_count?status=IN_SHIPPING_COMPANY_WHAREHOUSE&shippingCompanyWarehouse=null`,
        icon: Task,
        title: "Orders without warehouse",
        listItemIconStyle: { minWidth: 35 },
    },
    {
        // href: "/merchant/orders",
        icon: EventNoteOutlined,
        title: "Tasks",
        listItemIconStyle: { minWidth: 35 },
        children: [
            {
                icon: FiberManualRecord,
                iconStyle: { fontSize: 10 },
                listItemIconStyle: { minWidth: 17 },
                title: "In warehouse",
                href: "/merchant/tasks/warehouses?status=IN_SHIPPING_COMPANY_WHAREHOUSE",
                noCollapse: true,
                children: [
                    {
                        icon: Remove,
                        iconStyle: { fontSize: 10 },
                        listItemIconStyle: { minWidth: 17 },
                        title: "Rescheduled Orders",
                        href: "/merchant/tasks/warehouses?status=ORDER_RESCHEDULED",
                    },
                    {
                        icon: Remove,
                        iconStyle: { fontSize: 10 },
                        listItemIconStyle: { minWidth: 17 },
                        title: "Assigned for transfer",
                        href: "/merchant/tasks/zones?status=TASK_ASSIGNED_TO_DRIVER_FOR_TRANSFER",
                    },
                    {
                        icon: Remove,
                        iconStyle: { fontSize: 10 },
                        listItemIconStyle: { minWidth: 17 },
                        title: "In Transit",
                        href: "/merchant/tasks/zones?status=TASK_PICKED_UP_FOR_TRANSFER",
                    },
                    {
                        icon: Remove,
                        iconStyle: { fontSize: 10 },
                        listItemIconStyle: { minWidth: 17 },
                        title: "Assigned for delivery",
                        href: "/merchant/tasks/tasks_count?status=TASK_ASSIGNED_TO_DRIVER_FOR_DROP_OFF",
                    },
                ]
            },
            {
                icon: FiberManualRecord,
                iconStyle: { fontSize: 10 },
                listItemIconStyle: { minWidth: 17 },
                title: "Out for delivery",
                href: "/merchant/tasks/zones?status=TASK_PICKED_UP_FOR_DROP_OFF",
            },
            {
                icon: FiberManualRecord,
                iconStyle: { fontSize: 10 },
                listItemIconStyle: { minWidth: 17 },
                title: "Being returned",
                href: `/merchant/tasks/returned`,
            },
            {
                icon: FiberManualRecord,
                title: "Completed tasks",
                iconStyle: { fontSize: 10 },
                listItemIconStyle: { minWidth: 17 },
                href: "/merchant/tasks/completed?status=TASK_COMPLETED",
            },
        ]
    },
    {
        href: "/merchant/orders/filter",
        icon: FilterList,
        title: "filterOrders",
        listItemIconStyle: { minWidth: 35 },
    },
    {
        href: "/merchant/tasks/filter",
        icon: FilterList,
        title: "Tasks filter",
        listItemIconStyle: { minWidth: 35 },
    },
    {
        href: "/merchant/warehouse",
        icon: Warehouse,
        title: "Warehouses",
        listItemIconStyle: { minWidth: 35 },
    },
    {
        href: "/merchant/users",
        icon: Group,
        title: "Users",
    },
    {
        href: "/merchant/drivers",
        icon: LocalShippingOutlined,
        title: "Drivers",
    },
    {
        href: "/merchant/integrations",
        icon: LinkOutlined,
        title: "Integrations",
        listItemIconStyle: { minWidth: 35 },
    },
    {
        href: "/merchant/zones",
        icon: MapRounded,
        title: "Zones",
        listItemIconStyle: { minWidth: 35 },
    },
    {
        icon: Person,
        title: "Account",
        children: [
            {
                href: "/merchant/account/plans",
                icon: Category,
                title: "Plans",
            },
            {
                href: "/merchant/account/subscription",
                icon: CreditCard,
                title: "Subscription",
            },
            {
                href: "/merchant/account/settings",
                icon: ManageAccounts,
                title: "Settings",
            }
        ]
    },
    {
        href: "/merchant/customizations",
        icon: Tune,
        title: "Customizations",
    },
    {
        href: "/merchant/transactions",
        icon: Paid,
        title: "Transactions",
    },
    {
        href: "/merchant/balance",
        icon: Wallet,
        title: "Wallet Balance",
    },
    {
        icon: WhatsApp,
        title: "Whatsapp Msgs",
        href: "/merchant/settings/whatsapp"
    },
    {
        href: "/terms-and-conditions",
        icon: Gavel,
        title: "Terms and Conditions",
    },
    {
        href: "/merchant/national-address-transactions",
        icon: LocationOn,
        title: "National Address Requests",
    },
]